<template>
  <sdPageHeader>
    <template #title>
      <div class="product-single-description">
        <sdHeading class="product-single-title" as="h1" style="margin: 0px">
         Bank Account Transactions
        </sdHeading>
      </div>
      <a-row :gutter="25">
        <a-col>
          <div class="setting-card-title">
          </div>
        </a-col></a-row
      >
    </template>
    
  </sdPageHeader>
  <Main>
    <sdCards headless v-if="loading">
      <div class="spin">
        <a-spin />
      </div>
    </sdCards>
    <sdCards headless v-else>
      <template v-if="selectedoption == 'Active'">
        <a-row :gutter="15" style="padding: 10px">
          <a-col :xs="24">
            <TopToolBox>
              <div class="product-single-description">
                <div
                  class="
                    product-single-title
                    page-header-actions
                    product-single-description
                  "
                  style="float: right"
                >
                  <a-button
                    class="btn-signin"
                    size="small"
                    type="default"
                    v-if="checkselected"
                    @click="bulkIgnore('B')"
                  >
                    <span
                      style="
                        display: inline-flex !important;
                        align-items: center !important;
                      "
                    >
                      <sdFeatherIcons type="x-circle" size="14" /> &nbsp;
                      Dismiss</span
                    >
                  </a-button>
                  <a-form
                      name="contact"
                      :model="addFormState"
                      :layout="addFormState.layout"
                      style="
                        margin-top: 20px;
                        margin-right: 10px;
                      "
                    >
                      <a-row  >
                        <a-col>
                          <a-form-item name="search_text">
                            <a-input
                              v-model:value="addFormState.search_text"
                              placeholder="Search Here...."
                              @change="handleSearch"
                            />
                          </a-form-item>
                        </a-col>
                      </a-row>
                    </a-form>
                   <a-button
                    class="btn-signin"
                    size="small"
                    @click="exportToCSV()"
                  >
                    <span
                      style="
                        display: inline-flex !important;
                        align-items: center !important;
                      "
                    >
                      <sdFeatherIcons type="download" size="14" /> &nbsp;
                      Export</span
                    >
                  </a-button>
                </div>
                <span style="margin: 0px; font-size: 16px; font-weight: 400">
                  <br />
                </span>
              </div>
            </TopToolBox>
          </a-col>
        </a-row>
        <a-row :gutter="15">
          <a-col :md="24">
            <TableWrapper class="table-responsive">
              <a-table
                :data-source="TableData"
                :columns="TableColumns"
                :pagination="{
                  defaultPageSize: 50,
                  total: TableData.length,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`,
                }"
              >
                
              </a-table>
            </TableWrapper>
          </a-col>
        </a-row>
      </template>
    </sdCards>
  </Main>
</template>

<script>
import {
  ContactPageheaderStyle,
  Action,
  UserTableStyleWrapper,
  TopToolBox,
  ProjectSorting,
} from "./style";
import { defineComponent } from "vue";
import { Main, CardToolbox, TableWrapper,BasicFormWrapper } from "../styled";
import { dispatch, useStore } from "vuex";
import {
  defineAsyncComponent,
  computed,
  reactive,
  ref,
  onMounted,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { message, Notification } from "ant-design-vue";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default defineComponent({
  name: "bank_transaction",
  components: {
    Main,
    BasicFormWrapper,
    CardToolbox,
    TopToolBox,
    UserTableStyleWrapper,
    TableWrapper,
    ProjectSorting,
  },
  setup() {
    var loading = ref(true);
    var checkselected = ref(false);
    var selectcount = ref(null);
    var selectedid = ref(null);
    var selectedoption = ref("Active");
    //const { dispatch, state } = useStore();

    const orgdata = ref(JSON.parse(localStorage.getItem("syncdata")));
    const store = useStore();
    onMounted(() => {
      getdata();
      
    });

    const addFormState = reactive({
      search_text: "",
      layout: "vertical",
    });

    const rules = {
      search_text: [
        {
          required: true,
          message: "Search Here....",
          trigger: "blur",
        },
      ],
      status: [
        {
          required: true,
          message: "Please Select a valid Option!",
          trigger: "blur",
        },
      ],
    };

  const handleSearch = (values) => {
    let substring = addFormState.search_text;
    store.state.xeroclient.data = JSON.parse(localStorage.getItem("search_data"));
    let xero_get_datas = [];
    (JSON.parse(localStorage.getItem("search_data"))).map((data,index) => {
      let search_match = false;
      search_match = (((data.is_customer).toLowerCase()).includes(substring.toLowerCase()));
      if(search_match == false){search_match = (((data.contact_name).toLowerCase()).includes(substring.toLowerCase()));
      }if(search_match == false){search_match = (((data.is_supplier).toLowerCase()).includes(substring.toLowerCase()));
      }if(search_match == false){search_match = (((data.date)).includes(substring));
      }
      if(search_match == false){
        (store.state.xeroclient.data).splice(index, 1);
      }else{
        
        xero_get_datas.push(JSON.parse(localStorage.getItem("search_data"))[index]);
      }
    });
    store.state.xeroclient.data = xero_get_datas;
  };
    const getdata = () => { 
      loading.value = true;
      console.log(store._actions);
      store.dispatch("getbankstamentDetails").then(
        (response) => {

          if (response.status == 200) {
            store.state.xeroclient.data = response.data;
            //localStorage.setItem("search_data",JSON.stringify(response.data));
            loading.value = false;
          } else {
            store.state.xeroclient.data = [];
            loading.value = false;
            //onCancel();
          }
        },
        (error) => {
          store.state.xeroclient.data = [];
          loading.value = false;
        }
      );
      //  store.state.xeroclient.data = [];
      //  loading.value = false;
    };
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows;
        if (selectedRowKeys.value.length == 0) {
          checkselected.value = false;
        } else {
          checkselected.value = true;
          selectedid = selectedRowKeys.value;
          selectcount.value = selectedRowKeys.value.length + " Rows Selected";
        }
      },
      getCheckboxProps: (record) => (
        {
          disabled: record.name === "Disabled User",
          name: record.name,
        },
        console.log(record)
      ),
    };


const TableColumns = computed(() => {
  const baseColumns = [
      {
        title: "Date",
        dataIndex: "transaction_date",
        key: "transaction_date",
        sorter: (a, b) => a.transaction_date.length - b.transaction_date.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Contact Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => a.name.length - b.name.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Merchant Name",
        dataIndex: "merchant_name",
        key: "merchant_name",
        sorter: (a, b) => a.merchant_name.length - b.merchant_name.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        sorter: (a, b) => a.amount.length - b.amount.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        sorter: (a, b) => a.type.length - b.type.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Currency",
        dataIndex: "currency",
        key: "currency",
        sorter: (a, b) => a.currency.length - b.currency.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        sorter: (a, b) => a.category.length - b.category.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Payment Channel",
        dataIndex: "payment_channel",
        key: "payment_channel",
        sorter: (a, b) => a.payment_channel.length - b.payment_channel.length,
        sortDirections: ["descend", "ascend"],
        align: "left",
      },
    ];


  return baseColumns;
});    
    let TableData = computed(() =>
      store.state.xeroclient.data.map((contact) => {
        const {
          id,
          company_id,
          plaid_account_id,
          transaction_id,
          name,
          merchant_name,
          amount,
          currency,
          transaction_date,
          category,
          payment_channel,

        } = contact;
        return {
          key: id,
          company_id:company_id,
          plaid_account_id : plaid_account_id,
          transaction_id : transaction_id ,
          name: name,
          merchant_name: merchant_name,
          amount:amount,
          currency:currency,
          transaction_date:transaction_date,
          category:category,
          payment_channel: payment_channel,
          
        };
      })
    );


     const exportToCSV = () => {
      const inputData = store.state.xeroclient.data.map((contact) => {
        const {
          id,
          company_id,
          plaid_account_id,
          transaction_id,
          name,
          merchant_name,
          amount,
          currency,
          transaction_date,
          category,
          payment_channel,
        } = contact;
        return {
          key: id,
          company_id:company_id,
          plaid_account_id : plaid_account_id,
          transaction_id : transaction_id ,
          name: name,
          merchant_name: merchant_name,
          amount:amount,
          currency:currency,
          transaction_date:transaction_date,
          category:category,
          payment_channel: payment_channel,
        };
      });
      var linedata1 = [];
      linedata1.push({
      Check : "Bank Transaction Details",
      //Client: orgdata.value.name,
      });
      const fileName =
        "Bank Transaction Details";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const ws = XLSX.utils.json_to_sheet(linedata1);
      XLSX.utils.sheet_add_json(ws,inputData,{ skipHeader: false, origin: "A" + (linedata1.length + 3) });
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      Notification["success"]({
        message: "Success!",
        description: "Downloaded.",
      });
    };
   
    return {
      loading,
      TableColumns,
      TableData,
      rowSelection,
      selectcount,
      checkselected,
      selectedoption,
      orgdata,
      addFormState,
      handleSearch,
      exportToCSV
    };
  },
});
</script>
 <style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #968f8f34;
}
#dismiss_btn {
  color: white;
  background-color: #5f63f2;
}
</style> 